import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { getIntercomAuth, IntercomAuthResponse } from '@/apis/admin-api/user';

export const useGetIntercomAuth = (userId: string | undefined, enabled = true) => {
  return useQuery<IntercomAuthResponse, AxiosError>({
    queryKey: ['intercom_auth', userId],
    queryFn: getIntercomAuth,
    refetchOnWindowFocus: false,
    enabled: enabled && Boolean(userId),
  });
};
